import { Grid } from '@mui/material'
import { Pagination as AntdPagination } from 'antd'

interface Props {
  total: number
  current: number
  pageSize: number
  onChange: (page: number, perPage: number) => void
  showSizeChanger?: boolean
  mb?: number
}

const Pagination = (props: Props) => {
  const {
    total = 0,
    current = 1,
    pageSize = 10,
    onChange,
    showSizeChanger = true,
    mb = 0,
  } = props
  return (
    <Grid
      container
      mt={1}
      spacing={2}
      alignItems={'center'}
      justifyContent={'flex-end'}
      mb={mb}
    >
      <Grid item>
        <AntdPagination
          total={total}
          pageSize={pageSize || 10}
          pageSizeOptions={['10', '15', '20', '30', '50', '100']}
          current={current}
          showSizeChanger={showSizeChanger}
          onChange={(page, pageSize) => onChange(page, pageSize)}
        />
      </Grid>
      {/* <Grid item>
      <Input
        style={{ width: 90 }}
        maxLength={4}
        placeholder="จำนวน"
        value={pageSize}
        onChange={(e) => onChange(current, validateMinMaxValue(e.target.value, 0, 1000) || 0)}
      />
    </Grid> */}
    </Grid>
  )
}

export default Pagination
